module.exports = __webpack_public_path__ + "img/Butterfly_00035.fd075daf.png";